<template>
  <div class="content-430">
    <div class="class-form-head">基础信息</div>
    <div class="class-form-content">
      <Form
        ref="baseInfo"
        :model="baseInfo"
        label-position="right"
        :label-width="120"
        :rules="baseInfoRule"
      >
        <FormItem label="课程提供方" prop="orgId">
          <Select
            v-model="baseInfo.orgId"
            filterable
            placeholder="请选择课程提供方"
            class="class-form-item"
            :disabled="
              theUserIdentity !== 'admin' || +$route.query.isShelves === 1
            "
            @on-change="handleChangeOrgId"
          >
            <Option
              v-for="(item, index) in providerList"
              :key="index"
              :value="item.orgId"
            >{{ item.name }}</Option>
          </Select>
          <div v-show="selectEdu">
            课程资源将上架至：{{ selectEdu }}
            <span
              v-if="+$route.query.isShelves !== 1"
              class="a-link"
              style="color: #5c45e5; cursor: pointer"
              @click="handleEditEduId"
            >修改</span>
          </div>
        </FormItem>
        <FormItem label="课程名称" prop="courseName">
          <Input
            v-model="baseInfo.courseName"
            :maxlength="30"
            placeholder="请输入课程名称"
            class="class-form-item"
            @on-blur="handleTrimValue('courseName')"
          ></Input>
        </FormItem>
        <FormItem label="课程资源学期" prop="termCode">
          <CascaderYearTerms
            ref="cascaderYearTerms"
            class="class-form-item"
            :placeholder="`请选择学期`"
            :need-init-data="false"
            :clearable="true"
            :disabled-year-term="!!courseId&&!isCopy"
            @on-change="getTermChange"
          ></CascaderYearTerms>
          <!-- <Select
            v-model="baseInfo.termId"
            placeholder="请选择课程资源学期"
            class="class-form-item"
            :disabled="+$route.query.isShelves === 1 && !isCopy"
          >
            <Option
              v-for="(item, index) in termList"
              :key="index"
              :value="item.termId"
            >{{ item.yearName + item.termName }}</Option>
          </Select> -->
        </FormItem>
        <FormItem label="课程类型" prop="courseType">
          <!-- <Cascader ref="cascaderBox" :value="formValidate.courseType" :disabled="formValidate.orgId==''||formValidate.orgId==-1" :data="courseTypeDataUse" :load-data="handleLoadData" class="w-90" :render-format="format" @on-change="handleCourseType"></Cascader> -->
          <Cascader
            ref="cascaderBox"
            v-model="baseInfo.courseType"
            placeholder="请选择课程类型"
            class="class-form-item"
            :data="courseTypeData"
            :disabled="baseInfo.orgId == '' || baseInfo.orgId == -1"
            :load-data="loadingCourseType"
            @on-change="changeCourseType"
          ></Cascader>
        </FormItem>
        <FormItem label="课程级别" prop="courseLevel">
          <Select
            v-model="baseInfo.courseLevel"
            placeholder="请选择课程级别"
            class="class-form-item"
          >
            <Option
              v-for="(item, index) in courseLevelList"
              :key="index"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="推荐年级" prop="gradeGroup">
          <Select v-model="baseInfo.gradeMin" class="w-40">
            <Option
              v-for="item in likeGradesList"
              :key="item.id"
              :value="item.id"
            >{{ item.name }}</Option>
          </Select>
          ~
          <Select v-model="baseInfo.gradeMax" class="w-40">
            <Option
              v-for="item in likeGradesList"
              :key="item.id"
              :value="item.id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="限报班人数" prop="studentSuggestGroup">
          <Input
            v-model="baseInfo.studentSuggestMin"
            placeholder="请输入"
            class="w-40"
          ></Input>
          至
          <Input
            v-model="baseInfo.studentSuggestMax"
            placeholder="请输入"
            class="w-40"
          ></Input>
          <div class="tip">{{ limitStr }}</div>
        </FormItem>
      </Form>
    </div>
    <Modal
      v-model="showEduSelect"
      :mask-closable="false"
      :closable="selectEdu ? true : false"
      :footer-hide="true"
      :width="400"
    >
      <div class="edu-title">选择教育局</div>
      <div class="edu-content">
        <RadioGroup v-model="eduIdSelect" @on-change="handleChangeEduId">
          <div v-for="(item, index) in eduList" :key="index" class="edu-item">
            <Radio :label="item.orgId">{{ item.name }}</Radio>
          </div>
        </RadioGroup>
      </div>
    </Modal>
  </div>
</template>
<script>
import resourcesManagementApi from '@/request/courseCenter/resources';
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import { likeGradesList, courseLevelList } from '../data/resources';
import { quelityTypeList, hostingTypeList, arrToObj } from '@/utils/dictionary';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import { baseInfo } from '../data/editCurriculumForm';
export default {
  components: {
    CascaderYearTerms
  },
  inject: ['EditCurriculumInstance'],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          orgId: '', // 提供方id
          courseName: '', // 课程资源名称
          educationBureauId: '', // 提供方所属教育局id
          // termId: '',
          yearCode: '',
          termCode: '',
          courseType: [], // 课程分类
          courseLevel: '', // 课程级别
          gradeGroup: '',
          gradeMin: '',
          gradeMax: '',
          studentSuggestGroup: false,
          studentSuggestMin: '', //
          studentSuggestMax: ''
        };
      }
    }, // v-model的值
    theUserIdentity: {
      type: String,
      default: ''
    },
    courseId: {
      type: String,
      default: ''
    },
    validatePass: {
      type: Boolean,
      default: false
    }, // 校验是否通过
    isCopy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateTermCode = (rule, value, callback) => {
      if (this.baseInfo.termCode) {
        callback();
      } else {
        callback(new Error('请选择课程资源学期'));
      }
    };
    const validatehasGrades = (rule, value, callback) => {
      if (this.baseInfo.gradeMin === '' && this.baseInfo.gradeMax === '') {
        this.baseInfo.gradeGroup = '';
        callback(new Error('推荐年级必填！'));
        return;
      }
      if (this.baseInfo.gradeMin === '' || this.baseInfo.gradeMax === '') {
        this.baseInfo.gradeGroup = '';
        callback(new Error('推荐年级必须填写完整！'));
        return;
      }
      this.baseInfo.gradeGroup = 'has';
      callback();
    };
    // 推荐报名人数
    const validateStudentSuggest = (rule, value, callback) => {
      if (
        !Number.isInteger(+this.baseInfo.studentSuggestMin) ||
        +this.baseInfo.studentSuggestMin < 0
      ) {
        this.baseInfo.studentSuggestMin = null;
        this.baseInfo.studentSuggestGroup = false;
        console.log('这是1');
        callback(new Error('请输入大于或等于0的整数'));
        return;
      } else if (
        !Number.isInteger(+this.baseInfo.studentSuggestMax) ||
        +this.baseInfo.studentSuggestMax < 0
      ) {
        this.baseInfo.studentSuggestMax = null;
        this.baseInfo.studentSuggestGroup = false;
        console.log('这是2');
        callback(new Error('请输入大于或等于0的整数'));
        return;
      } else if (
        this.baseInfo.studentSuggestMax &&
        +this.baseInfo.studentSuggestMin > +this.baseInfo.studentSuggestMax
      ) {
        this.baseInfo.studentSuggestGroup = false;
        console.log('这是3');
        callback(new Error('右边的值应该大于左边的值！'));
        return;
      }
      this.baseInfo.studentSuggestGroup = true;
      console.log('这是4', this.baseInfo.studentSuggestGroup);
      callback();
    };
    return {
      baseInfoRule: {
        orgId: [
          { required: true, message: '请选择课程提供方', trigger: 'change' }
        ],
        courseName: [
          { required: true, message: '请输入课程名称', trigger: 'blur' }
        ],
        // termId: [
        //   { required: true, message: '请选择课程资源学期', trigger: 'change' }
        // ],
        termCode: [
          { required: true, validator: validateTermCode, trigger: 'change' }
        ],
        courseType: [
          {
            required: true,
            type: 'array',
            message: '请选择课程类型',
            trigger: 'change'
          }
        ],
        courseLevel: [
          {
            required: true,
            type: 'number',
            message: '请选择课程级别',
            trigger: 'change'
          }
        ],
        gradeGroup: [
          { required: true, validator: validatehasGrades, trigger: 'change' }
        ],
        studentSuggestGroup: [
          { validator: validateStudentSuggest, trigger: 'blur' }
        ]
      }, // 基础信息表单
      providerList: [], // 课程提供方列表
      selectEdu: '', // 提供方所属的教育局（当提供方隶属于多个教育局的时候会出现这个提示）
      eduList: [], // 教育局列表
      showEduSelect: false, // 选择教育局弹窗是否显示
      eduIdSelect: '', // 选择的教育局id(用于radio group的展示)
      courseLevelList: [...courseLevelList], // 课程级别
      likeGradesList: [...likeGradesList], // 年级列表
      courseTypeData: [
        {
          value: '1',
          label: '素质课程',
          loading: false,
          tag: 'first',
          children: []
        },
        {
          value: '2',
          label: '托管',
          loading: false,
          tag: 'first',
          children: []
        }
      ], // 课程类型
      quelityTypeObj: arrToObj(quelityTypeList), // 素质课二级分类
      hostingTypeObj: arrToObj(hostingTypeList), // 托管二级分类
      termList: [], // 年度学期列表
      termArr: ['', '第一学期', '第二学期']
    };
  },
  computed: {
    baseInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }, // 课程信息
    limitStr() {
      if (!this.baseInfo.studentSuggestGroup) {
        console.log('limit0', this.baseInfo.studentSuggestGroup);
        return '';
      }
      if (this.baseInfo.studentSuggestMin && this.baseInfo.studentSuggestMax) {
        console.log('limit1');
        return `${this.baseInfo.studentSuggestMin}人至${this.baseInfo.studentSuggestMax}人`;
      }
      if (this.baseInfo.studentSuggestMin) {
        console.log('limit2');
        return `${this.baseInfo.studentSuggestMin}人以上`;
      }
      if (this.baseInfo.studentSuggestMax) {
        console.log('limit3');
        return `${this.baseInfo.studentSuggestMax}人以下`;
      }
      console.log('limit4');
      return '';
    }
  },
  watch: {
    'baseInfo.orgId'(newVal) {
      if (newVal) {
        this.getRelEduFun();
      }
      this.courseLevelList = [...courseLevelList]; // 课程级别
    },
    baseInfo: {
      handler(newVal, oldVal) {
        this.EditCurriculumInstance.findRuleRequireNew(
          this,
          'baseInfo',
          '基础信息'
        );
      },
      deep: true
    }
  },
  created() {
    this.getCourseProviderList();
  },
  mounted() {
    this.EditCurriculumInstance.findRuleRequireNew(
      this,
      'baseInfo',
      '基础信息'
    );
  },
  methods: {
    async getTermChange(e) {
      if (e && e.length === 2) {
        this.baseInfo.yearCode = e[0];
        this.baseInfo.termCode = e[1];
      } else {
        this.baseInfo.yearCode = '';
        this.baseInfo.termCode = '';
      }
    },
    // 校验表单
    checkForm() {
      this.$refs.baseInfo.validate((valid) => {
        console.log(valid, this.baseInfo);
        if (valid) {
          this.$emit('update:validatePass', true);
        } else {
          this.EditCurriculumInstance.findRuleRequireNew(
            this,
            'baseInfo',
            '基础信息',
            true
          );
          this.$emit('update:validatePass', false);
        }
      });
    },
    handleTrimValue(keyName) {
      if (!keyName) {
        return null;
      }
      this.baseInfo[keyName] = this.baseInfo[keyName].trim();
    },
    // 课程提供方
    async getCourseProviderList() {
      try {
        const resp = await resourcesManagementApi.getCourseProviderList({
          passSts: 1
        });
        if (resp.status === 200) {
          this.providerList = resp.message;
        }
      } catch (err) {
        console.log('err-->', err);
      }
    },
    // 获取年度学期
    // async getTermList() {
    //   const params = {
    //     orgId: this.baseInfo.orgId,
    //     relEduId: this.baseInfo.educationBureauId
    //   };
    //   const res = await resourcesManagementApi.getYearTerm(params);
    //   if (res.status === 200) {
    //     this.termList = res.message;
    //   }
    // },
    // radio group 选中某个教育局之后，执行的操作
    handleChangeEduId() {
      // this.baseInfo.termId = '';
      this.baseInfo.trainingType = '';
      this.baseInfo.courseTypeId = '';
      this.baseInfo.courseType = [];
      this.courseTypeData = [
        {
          value: '1',
          label: '素质课程',
          loading: false,
          tag: 'first',
          children: []
        },
        {
          value: '2',
          label: '托管',
          loading: false,
          tag: 'first',
          children: []
        }
      ];
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.cascaderBox.updateSelected();
        }, 500);
      });
      this.getEduSelect();
    },
    getEduSelect() {
      this.baseInfo.educationBureauId = this.eduIdSelect;
      const obj = this.eduList.find((item) => {
        return item.orgId === this.baseInfo.educationBureauId;
      });
      this.showEduSelect = false;
      this.selectEdu = obj.name;
      this.eduIdSelect = '';
      // this.getTermList();
    },
    // 切换课程提供方
    handleChangeOrgId() {
      this.selectEdu = '';
      // this.baseInfo.termId = '';
      this.baseInfo.trainingType = '';
      this.baseInfo.courseTypeId = '';
      this.baseInfo.courseType = [];
      this.courseTypeData = [
        {
          value: '1',
          label: '素质课程',
          loading: false,
          tag: 'first',
          children: []
        },
        {
          value: '2',
          label: '托管',
          loading: false,
          tag: 'first',
          children: []
        }
      ];
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.cascaderBox.updateSelected();
        }, 500);
      });
    },
    // 修改教育局id
    handleEditEduId() {
      this.eduIdSelect = this.baseInfo.educationBureauId;
      this.showEduSelect = true;
    },
    // 获取提供方所属教育局
    async getRelEduFun() {
      const res = await resourcesManagementApi.getRelEdu({
        orgId: this.baseInfo.orgId
      });
      if (res.status === 200) {
        this.eduList = res.message;
        // 所属教育局只有一个的，不用弹窗
        if (this.eduList.length === 1) {
          this.baseInfo.educationBureauId = this.eduList[0].orgId;
          // this.getTermList();
        } else if (this.eduList.length > 1 && this.courseId) {
          console.log('拿到的教育局id', this.baseInfo.educationBureauId);
          // 编辑进来而且有多个教育局的
          const obj = this.eduList.find((item) => {
            return item.orgId === this.baseInfo.educationBureauId;
          });
          console.log('拿到的教育局id找到的', obj);
          this.selectEdu = obj.name;
          // this.getTermList();
        } else if (this.eduList.length > 1) {
          // 新增资源且有多个教育局的
          this.showEduSelect = true;
        }
      }
    },
    setTerm() {
      this.$refs.cascaderYearTerms.yearTerms = [this.baseInfo.yearCode, '' + this.baseInfo.termCode];
    },
    async updateCascaderBox() {
      try {
        // 级联第二级
        const secondList = await this.getSecondList({
          value: this.baseInfo.trainingType + ''
        });
        this.courseTypeData[this.baseInfo.trainingType - 1].children =
          secondList;
        this.courseTypeData[this.baseInfo.trainingType - 1].loading = false;
        // 级联第三级
        const thirdList = await this.getThirdList({
          value: this.baseInfo.courseType[1] + ''
        });
        const index = secondList.findIndex((item) => {
          return item.value === this.baseInfo.courseType[1] + '';
        });
        this.courseTypeData[this.baseInfo.trainingType - 1].children[
          index
        ].children = thirdList;
        this.courseTypeData[this.baseInfo.trainingType - 1].children[
          index
        ].loading = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.cascaderBox.updateSelected();
          }, 500);
        });
      } catch (err) {
        console.log(err, '================');
      }
    },
    async loadingCourseType(item, callback) {
      if (item.tag === 'first') {
        item.loading = true;
        item.children = await this.getSecondList(item);
        item.loading = false;
        callback();
      }
      if (item.tag === 'second') {
        item.loading = true;
        item.children = await this.getThirdList(item);
        item.loading = false;
        callback();
      }
    },
    // 获取二级分类
    async getSecondList(item) {
      return new Promise(async(resolve, reject) => {
        console.log('二级分类----', this.baseInfo);
        let params = {};
        if (this.theUserIdentity === 'org') {
          params = {
            courseTypeAttr: item.value,
            orgId: this.baseInfo.educationBureauId
          };
        } else {
          params = {
            courseTypeAttr: item.value,
            orgId: this.baseInfo.orgId,
            eduId: this.baseInfo.educationBureauId
          };
        }

        const res = await courseCenterApi.getTapList(params);
        if (res.status === 200) {
          resolve(this.filterList(res.message, item.value));
        } else {
          reject([]);
        }
      });
    },
    async getThirdList(item) {
      // getCourseTypeTapList
      return new Promise(async(resolve, reject) => {
        let params = {};
        if (this.theUserIdentity === 'org') {
          params = {
            courseTypeKind: item.value,
            orgId: this.baseInfo.educationBureauId
          };
        } else {
          params = {
            courseTypeKind: item.value,
            orgId: this.baseInfo.orgId,
            eduId: this.baseInfo.educationBureauId
          };
        }
        const res = await courseCenterApi.getCourseTypeTapList(params);
        if (res.status === 200) {
          const list = res.message.map((x) => {
            return {
              value: x.courseTypeId,
              label: x.courseTypeName
            };
          });
          resolve(list);
        } else {
          reject([]);
        }
      });
    },
    filterList(list, type) {
      let tag = '';
      if (type === '1') {
        tag = 'quelityTypeObj';
      } else if (type === '2') {
        tag = 'hostingTypeObj';
      }
      const typeList = [];
      list.forEach((item) => {
        const obj = this[tag][item];
        const objType = {};
        Object.assign(objType, obj, {
          children: [],
          loading: false,
          tag: 'second'
        });
        typeList.push(objType);
      });
      console.log('是啥------', typeList);
      return typeList;
    },
    changeCourseType(value, selectedData) {
      if (value && value.length > 0) {
        this.baseInfo.trainingType = value[0];
        this.baseInfo.courseTypeId = value[2];
      } else {
        this.baseInfo.trainingType = '';
        this.baseInfo.courseTypeId = '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.edu-title {
  text-align: center;
  font-weight: bold;
}
.edu-content {
  padding: 16px 0;
  .edu-item {
    background: #f2f2f2;
    border-radius: 8px;
    width: 360px;
    line-height: 38px;
    margin-bottom: 10px;
    padding: 0 20px;
  }
}
</style>
